
export enum ObjectTypeEnum {
  None,                                   // 0
  Book,                                   // 1
  Comment,                                // 2
  Follow,                                 // 3
  Friend,                                 // 4
  Like,                                   // 5
  Quote,                                  // 6
  Rate,                                   // 7
  Review,   // 8
  Feed,                                   // 9
  List,       // 10
  Activity,                               // 11
  Progress,                               // 12
  Challenge,                              // 13
  Post,                                   // 14
  Story,                                  // 15
  Tag,                                    // 16
  Mention,                                // 17
  Genre,                                  // 18
  Message,                                // 19
  DirectChat,                             // 20
  GroupChat,                              // 21
  Booklist,                               // 22
  Club,                                   // 23
  Poll,                                   // 24
  Course,                                 // 25
  Meeting,                                // 26
  ChallengeV2,                            // 27
  Achievement,                            // 28
  UserChallenge,                          // 29
  badge,                                  // 30
  JoinRequest,                            // 31
  Reaction,                               // 32
  UserReportPublished,                    // 33
  FollowRequest,                          // 34


  SharedUser = 100,
  SharedAuthor,
  SharedPublisher,
  SharedLink,

  UnsupportedMedia = 404,
}


